var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardStrainGauge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BF4DDF6E-F518-4430-BC36-63C0EC661B6D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1033.000000, -1464.000000)",
    id: "icon/straingauge"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1033.000000, 1464.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,27 C1.44771525,27 1,26.5522847 1,26 L1,22 C1,21.4477153 1.44771525,21 2,21 L19,21 L19,19 L2,19 C1.48716416,19 1.06449284,18.6139598 1.00672773,18.1166211 L1,18 L1,14 C1,13.4477153 1.44771525,13 2,13 L19,13 L19,11 L2,11 C1.48716416,11 1.06449284,10.6139598 1.00672773,10.1166211 L1,10 L1,6 C1,5.44771525 1.44771525,5 2,5 L30,5 C30.5522847,5 31,5.44771525 31,6 L31,11 C31,11.5522847 30.5522847,12 30,12 L26,12 C25.4477153,12 25,11.5522847 25,11 L25,7 L3,7 L3,9 L20,9 C20.5128358,9 20.9355072,9.38604019 20.9932723,9.88337887 L21,10 L21,14 C21,14.5522847 20.5522847,15 20,15 L3,15 L3,17 L20,17 C20.5128358,17 20.9355072,17.3860402 20.9932723,17.8833789 L21,18 L21,22 C21,22.5522847 20.5522847,23 20,23 L3,23 L3,25 L24.999,25 L25,21 C25,20.4871642 25.3860402,20.0644928 25.8833789,20.0067277 L26,20 L30,20 C30.5522847,20 31,20.4477153 31,21 L31,26 C31,26.5522847 30.5522847,27 30,27 L2,27 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardStrainGauge);
export default __webpack_public_path__ + "static/media/DashboardStrainGauge.5e2ceb70c32b050913d5d6fb17c760c9.svg";
export { ForwardRef as ReactComponent };